<div [ngClass]="currentPage" *ngIf="buyer && buyer.pointSetting">
  <div class="inner">
    <div class="bar">
      <span class="membership-status" style="width: 100%;">
        <p>{{ buyer.firstName }}, here is your membership status:</p>
      </span>
      <!-- <span class="price" style="right: 1px;"></span> -->
    </div>
    <div class="current-status-box">
      <div class="current-status-icon">
        <img src="/assets/images/membership/{{ buyer.pointSetting.id }}.svg" alt="" />
      </div>
      <div class="current-status-top">
        Your current status
        <p class="current-level-code" *ngIf="currentPage === 'main-benefits'"><a [routerLink]="['/my/membership']"
            style="color: #e04fa3;">{{ buyer.pointSetting.levelCode }}</a></p>
        <p class="current-level-code" *ngIf="currentPage === 'mypage-benefits'">{{ buyer.pointSetting.levelCode }}</p>
        <p class="current-level-name">{{ buyer.pointSetting.levelName }}</p>
      </div>
      <div class="last-month-msi">
        <dl>
          <dt>Previous quarter total MSI purchase:</dt>
          <dd>
            <div>
              <span>
                ${{
                  (buyer.preMsiPrice
                    ? buyer.preMsiPrice
                    : 0
                  ).toFixed(2) | currency: 'USD':'':'0.2'
                }}
              </span>
            </div>
          </dd>
        </dl>
      </div>
      <div class="current-reward">
        <dl>
          <dt>Current reward:</dt>
          <dd *ngIf="buyer.pointSetting.id === 5">
            <span style="font-size: 14px; font-weight: 500; padding-top: 0;">$30 coupon<br>MOA
              $500</span>
          </dd>
          <dd *ngIf="buyer.pointSetting.id > 5">
            <span>{{ buyer.pointSetting.pointReward }}</span>
          </dd>
        </dl>
      </div>
    </div>
    <div class="next-month-status-box">
      <div class="next-month-status-top">
        Your next quarter status
      </div>
      <div class="current-month-msi">
        <dl>
          <dt>Total MSI spend so far:</dt>
          <dd>
            <span>
              ${{
                (buyer.curMsiPrice
                  ? buyer.curMsiPrice
                  : 0
                ).toFixed(2) | currency: 'USD':'':'0.2'
              }}
            </span>
          </dd>
        </dl>
      </div>
      <div class="next-month-status">
        <dl>
          <dt>Membership status:</dt>
          <dd>
            <span>{{ buyer.nextMonthPointSetting.levelCode }}</span>
            <p>{{ buyer.nextMonthPointSetting.levelName }} ({{ buyer.nextMonthPointSetting.point }}%)</p>
          </dd>
        </dl>
      </div>
      <div class="next-month-status-bar">
        <ng-container *ngIf="buyer.curMsiPrice >= buyer.levelUpPointSetting.msiPrice">
          <span class="msi-bar" style="width: 100%;"></span>
          <span class="msi" style="right: 1px;"></span>
        </ng-container>
        <ng-container *ngIf="buyer.curMsiPrice < buyer.levelUpPointSetting.msiPrice">
          <span class="msi-bar"
            [ngStyle]="{ width: (buyer.curMsiPrice * 100) / buyer.levelUpPointSetting.msiPrice + '%' }"></span>
          <span class="msi"
            [ngStyle]="{ right: 'calc(100% - ' + (buyer.curMsiPrice * 100) / buyer.levelUpPointSetting.msiPrice + '% + 1px)' }"></span>
        </ng-container>
        <span class="caption">Level up to <p>{{ buyer.levelUpPointSetting.levelName }}
            ({{ buyer.levelUpPointSetting.point }}%)</p> by ordering an additional [ <p>
            ${{
            (buyer.levelUpPointSetting.levelUpPrice
              ? buyer.levelUpPointSetting.levelUpPrice
              : 0
            ).toFixed(2) | currency: 'USD':'':'0.2'
          }}
          </p>
          ]</span>
      </div>
    </div>
  </div>
</div>
